export const APP_NAME = "LexiPro";
export const PRIMARY_COLOR = "#10B981";
export const LOGO_URL = "/logo.svg";
